import React, { useState, useEffect } from 'react';
import { Plus, Trash2} from 'lucide-react'; 
import './Despeses.css'; 
import API_URL from '../config';

function Despeses() {
  const [despeses, setDespeses] = useState([]);
  const [carregant, setCarregant] = useState(true);
  const [error, setError] = useState('');
  const [mostrarFormulari, setMostrarFormulari] = useState(false);
  const [concepte, setConcepte] = useState('');
  const [importDespesa, setImportDespesa] = useState('');
  const [categoria, setCategoria] = useState('');
  const [llistaClients, setLlistaClients] = useState([]);
  const [clientId, setClientId] = useState('');

  const carregarDespeses = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      setError('No estàs autenticat.');
      setCarregant(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/gestio/despeses/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setDespeses(data);
      } else {
        setError('Error al carregar les despeses.');
      }
    } catch (err) {
      setError(`Error de connexió: ${err.message}`);
    } finally {
      setCarregant(false);
    }
  };

  const carregarClients = async () => {
    const token = sessionStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/gestio/clients/`, {
        headers: { 'Authorization': `Token ${token}` }
    });
    if (response.ok) {
        const data = await response.json();
        setLlistaClients(data);
    }
  };

  useEffect(() => {
    carregarDespeses();
    carregarClients();
  }, []);


  const handleGuardarDespesa = async (e) => {
    e.preventDefault();
    const token = sessionStorage.getItem('token');
    
    const novaDespesa = { 
      concepte, 
      import_despesa: importDespesa, 
      categoria,
      client: clientId || null
    };

    try {
      const response = await fetch(`${API_URL}/api/gestio/despeses/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        },
        body: JSON.stringify(novaDespesa)
      });

      const textResposta = await response.text(); 
      console.log("Resposta del servidor:", textResposta);

      if (response.ok) {
        setMostrarFormulari(false); 
        setConcepte(''); setImportDespesa(''); setCategoria(''); 
        carregarDespeses(); 
      } else {
        alert("Error en guardar la despesa");
        alert("Error al servidor: " + textResposta);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleEsborrar = async (id) => {
    if (!window.confirm('Estàs segur que vols esborrar aquesta despesa?')) {
      return;
    }

    const token = sessionStorage.getItem('token');
    
    if (!token) {
      setError('No estàs autenticat.');
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/gestio/despeses/${id}/esborrar/`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        setDespeses(despeses.filter(despesa => despesa.id !== id));
      } else {
        setError('Error al esborrar la despesa.');
      }
    } catch (err) {
      setError(`Error de connexió: ${err.message}`);
    }
  };

  return (
    <div className="seccio-clients">
      <div className="capçalera-llista">
        <div className="text-llista">
          <h1>Gestió de Despeses</h1>
          <p>Controla les despeses generals i vinculades a clients.</p>
        </div>
        <button className="boto-afegir" onClick={() => setMostrarFormulari(true)}>
          <Plus size={18} /> Afegir Despesa
        </button>
      </div>

      <div className="taula-contenidor">
        {error && <div className="missatge-error">{error}</div>}

        {carregant ? (
          <p>Carregant dades...</p>
        ) : despeses.length === 0 ? (
          <p className="missatge-buit">No tens cap despesa registrada.</p>
        ) : (
          <table className="taula-personalitzada">
            <thead>
              <tr>
                <th>Concepte</th>
                <th>Categoria</th>
                <th>Client</th>
                <th>Data</th>
                <th>Import</th>
                <th>Accions</th>
              </tr>
            </thead>
            <tbody>
              {despeses.map(d => (
                <tr key={d.id}>
                  <td><strong>{d.concepte}</strong></td>
                  <td><span className="tag-categoria">{d.categoria}</span></td>
                  <td className={d.nom_client ? "" : "text-muted"}>
                    {d.nom_client || 'General'}
                  </td>
                  <td>{new Date(d.data).toLocaleDateString()}</td>
                  <td className="import-negatiu">-{d.import_despesa}€</td>
                  <td className="accions">
                    <button className="icon-btn vermell" onClick={() => handleEsborrar(d.id)}>
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {mostrarFormulari && (
        <div className="Formulari-overlay">
          <div className="Formulari-modal">
            <div className="Formulari-capçalera">
              <h2>Nova Despesa</h2>
              <button className="boto-tancar" onClick={() => setMostrarFormulari(false)}>X</button>
            </div>
            
            <form onSubmit={handleGuardarDespesa} className="Formulari-cos">
              <input type="text" placeholder="Concepte" value={concepte} onChange={(e) => setConcepte(e.target.value)} required />
              <input type="number" placeholder="Import" value={importDespesa} onChange={(e) => setImportDespesa(e.target.value)} required />
              <input type="text" placeholder="Categoria" value={categoria} onChange={(e) => setCategoria(e.target.value)} required />
              
              {/* SELECTOR DE CLIENTS */}
              <select value={clientId} onChange={(e) => setClientId(e.target.value)}>
                <option value="">-- Despesa General (sense client) --</option>
                {llistaClients.map(c => (
                  <option key={c.id} value={c.id}>{c.nom_complet}</option>
                ))}
              </select>

              <button type="submit" className="boto-guardar">Guardar Despesa</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Despeses;